<script setup lang="ts">
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const props = withDefaults(
        defineProps<
            FormInputProps & {
                min?: number;
                max?: number;
                step?: number;
            }
        >(), {
        min: 0,
        max: 10000,
        step: 0.01,
    });
    const inputData: FormInputData = useFormInput(props);
</script>

<template>
    <FormFormattedNumberInput
        :inputName="inputName"
        :label="label"
        :placeholder="placeholder"
        :form="form"
        :model="model"
        :min="min"
        :max="max"
        :step="step"
        :disabled="inputData.props.disabled"
        :size="size"
        :mask="(value) => value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })"
        :unmask="(value) => parseFloat(value)"
        :without-label="inputData.props.withoutLabel"
        :class-name="inputData.props.className"
        :element-class-name="inputData.props.elementClassName"
        :container-class-name="inputData.props.containerClassName"
    />
</template>
